import React from 'react';
import { GiftCardContract } from '../../../types/GiftCard';
import GiftCardPaymentSummary from '../../content/GiftCardPaymentSummary';
import SectionSummary, { SectionSummaryGroupPosition } from '../SectionSummary';

export type NoPaymentSummaryProps = {
  groupPosition?: SectionSummaryGroupPosition;
  appliedGiftCards?: GiftCardContract[];
  onPaymentEdit?: () => void;
};

const NoPaymentSummary: React.FC<NoPaymentSummaryProps> = ({
  groupPosition,
  appliedGiftCards = [],
  onPaymentEdit,
}: NoPaymentSummaryProps) => {
  const renderNoPaymentRequiredSummary = () => {
    return (
      <div>
        <div>No additional payment required</div>
        <GiftCardPaymentSummary giftCards={appliedGiftCards} />
      </div>
    );
  };

  return appliedGiftCards.length > 0 ? (
    <SectionSummary
      title="Payment"
      content={renderNoPaymentRequiredSummary()}
      groupPosition={groupPosition}
      displayActionButton
      actionButtonText="Edit"
      onActionButtonClicked={onPaymentEdit}
      toolTipKey="NoPaymentSummaryKey"
      linkButtonDataTestId="LinkButton-input-NoPayment-Summary"
    />
  ) : (
    <SectionSummary
      title="Payment"
      content={renderNoPaymentRequiredSummary()}
      groupPosition={groupPosition}
      toolTipKey="NoPaymentSummaryKey"
      linkButtonDataTestId="LinkButton-input-NoPayment-Summary"
    />
  );
};

export default NoPaymentSummary;
